import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Form, Icon, Input, Button, Upload, Select, Table, DatePicker, Avatar, notification, Popconfirm } from 'antd';
import { loginUser } from '../../Redux/actions/authActions'
import Highlighter from 'react-highlight-words';
import logo from '../../assets/pantrylogo.png'
import Footer from '../../Components/Footer'
import axios from 'axios'
import SubmitButton from '../../Components/SubmitButton'
import moment from 'moment'
import { serverUrl } from '../../Config/api'

var expandData = []
const { Option } = Select
const { TextArea } = Input;
const saleType = ["A", "B", "C"]

const title = "Error"

const props = {
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    listType: 'picture',
};

const data = [];
for (let i = 1; i < 46; i++) {
    data.push({
        key: i,
        name: `Q&A_00${i}`,
        topic: i,
        ans1: 'h',
        consumer: i,
        address: i > 4 ? `A_0${Math.round(i / 4) > 4 ? Math.round(Math.round(i / 4) / 4) : Math.round(i / 4)}` : `A_0${i}`
    });
}

class ProductGroup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            fileList: [],
            selectedRowKeys: [],
            loading: false,
            filteredInfo: null,
            sortedInfo: null,
            searchText: '',
            searchedColumn: '',
            disableUpload: false,
            StartDateValue: '',
            EndDateValue: '',
            disable: false,
            tableData: [],
            allData: [],
            focusData: [],
            formData: [],
            visible: false
        }
    }

    async componentDidMount() {
        const { user } = this.props
        const { tableData } = this.state

        if (!user || user.role !== 'admin') {
            this.props.history.replace('/login')
        }

        axios.get(`${serverUrl}/admin/get/get-product/${user._id}`)
            .then((result) => {
                const { data } = result.data
                for (var i in data) {
                    var { excelFileObj, groceryName, _id } = data[i]
                    for (var j in excelFileObj) {
                        var length = 0
                        for (var k in excelFileObj[j]) {
                            length += excelFileObj[j][k].length
                        }
                        tableData.push({
                            key: _id,
                            grocery: groceryName,
                            name: j,
                            product: length,
                            productType: Object.keys(excelFileObj[j]).length,
                            delete: _id,
                            index: i
                        })
                    }
                }
                this.setState({ tableData, allData: data })
            })

        axios.post(`${serverUrl}/user/get-users`, { country: user.country })
            .then((response) => {
                let formData = response.data.data
                this.setState({ formData })
            })
    }

    clearFilters = () => {
        this.setState({ filteredInfo: null });
    };

    clearAll = () => {
        this.setState({
            filteredInfo: null,
            sortedInfo: null,
        });
    };

    setAgeSort = () => {
        this.setState({
            sortedInfo: {
                order: 'ascend',
                columnKey: 'name',
            },
        });
    };

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
            </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
            </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
    });

    normFile = e => {
        this.setState({ disableUpload: false })
        if (e.file && e.file.type.indexOf('image')) {
            // this.openNotification(title, 'Please Upload an Image', 'close-circle', 'red')
            return
        }
        if (Array.isArray(e)) {
            return e;
        }
        if (e.fileList.length) {
            this.setState({ disableUpload: true, fileList: e.fileList })
        }
        // return e && e.fileList;
    }

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    expandedRowRender = () => {
        console.log('expand', expandData)
        const columns = [
            {
                title: 'Product Types',
                ellipsis: true,
                children: [
                    {
                        title: 'Name 1',
                        dataIndex: 'pt1',
                        ellipsis: true,
                    },
                    {
                        title: 'Name 2',
                        dataIndex: 'pt2',
                        ellipsis: true,
                    },
                    {
                        title: 'Name 3',
                        dataIndex: 'pt3',
                        ellipsis: true,
                    },
                    {
                        title: 'Name 4',
                        dataIndex: 'pt4',
                        ellipsis: true,
                    },
                    {
                        title: 'Name 5',
                        dataIndex: 'pt5',
                        ellipsis: true,
                    }
                ]
            }
        ]
        var obj = Object.keys(expandData)
        const data = [{
            pt1: obj[0],
            pt2: obj[1] ? obj[1] : '',
            pt3: obj[2] ? obj[2] : '',
            pt4: obj[3] ? obj[3] : '',
            pt5: obj[4] ? obj[4] : '',
            key: 0
        }]
        return <Table columns={columns} dataSource={data} pagination={false} />;
    };

    handleExpand = (row) => {
        const { allData } = this.state
        expandData = allData[row.index]['excelFileObj'][row.name]
    }

    createCopyData(v) {
        const { setFieldsValue } = this.props.form
        const { name, description } = v
        setFieldsValue({
            name,
            description
        })
        this.openNotification('Success', 'Successfully Copy Data', 'check')
    }

    handleSubmit = e => {
        const { user, form } = this.props
        const { resetFields, validateFields } = form
        e.preventDefault();
        validateFields((err, values) => {
            if (!err) {
                this.setState({ disable: true, loading: true })
                values.userId = user._id
                values.country = user.country
                axios.post(`${serverUrl}/admin/post/add-pg`, values)
                    .then((result) => {
                        if (result.data.success) {
                            this.openNotification('Success', result.data.message, 'check')
                            this.setState({ disable: false, loading: false })
                            resetFields()
                            window.location.reload()
                        }
                        else {
                            this.openNotification(title, result.data.message, 'close-circle', 'red')
                            this.setState({ disable: false, loading: false })
                        }
                    })
                    .catch((err) => {
                        this.openNotification(title, "OOPS Something went wrong!!!", 'close-circle', 'red')
                        this.setState({ disable: false, loading: false })
                    })
            }
        });
    }

    openNotification = (title, desc, icon, color = '#108ee9') => {
        notification.open({
            message: title,
            description: desc,
            icon: <Icon type={icon} style={{ color: color }} />,
        });
    };

    disabledEndDate(current) {
        return current < moment(this.state.StartDateValue).add(1, 'day')
    }

    disabledStartDate(current) {
        return current > moment(this.state.EndDateValue)
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            sortedInfo: sorter,
        });
    };

    async deleteData(v) {
        let { tableData } = this.state
        await axios.post(`${serverUrl}/admin/post/pg-delete`, { id: v })
            .then((res) => {
                const { data } = res
                if (data.success) {
                    tableData = tableData.filter(i => i.key !== v)
                    this.setState({ tableData })
                    this.openNotification('Success', 'Successfully Deleted Data', 'check')
                }
                else {
                    this.openNotification('Error', 'Something Went Wrong!!!', 'close-circle', 'red')
                }
            })
            .catch((e) => {
                this.openNotification('Error', 'Something Went Wrong!!!', 'close-circle', 'red')
            })
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        let { sortedInfo, filteredInfo, loading, disable, tableData, formData } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};

        const columns = [
            {
                title: 'Grocery',
                dataIndex: 'grocery',
                sorter: (a, b) => a.grocery.length - b.grocery.length,
                sortOrder: sortedInfo.columnKey === 'grocery' && sortedInfo.order,
                ellipsis: true,
                ...this.getColumnSearchProps('grocery'),
            },
            {
                title: 'Name',
                dataIndex: 'name',
                sorter: (a, b) => a.name.length - b.name.length,
                sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
                ellipsis: true,
                ...this.getColumnSearchProps('name'),
            },
            {
                title: 'Total Products',
                dataIndex: 'product',
                sorter: (a, b) => a.product.length - b.product.length,
                sortOrder: sortedInfo.columnKey === 'product' && sortedInfo.order,
                ellipsis: true
            },
            {
                title: 'Total Products Types',
                dataIndex: 'productType',
                sorter: (a, b) => a.productType.length - b.productType.length,
                sortOrder: sortedInfo.columnKey === 'productType' && sortedInfo.order,
                ellipsis: true
            },
            // {
            //     title: 'Operation',
            //     dataIndex: 'action',
            //     ellipsis: true,
            //     render: (v) => <Button onClick={() => this.createCopyData(v)}>Create</Button>
            // },
            // {
            //     title: 'Delete',
            //     dataIndex: 'delete',
            //     ellipsis: true,
            //     render: (v) => <Popconfirm
            //         title="Are you sure delete this data?"
            //         onConfirm={() => this.deleteData(v)}
            //         okText="Yes"
            //         cancelText="No"
            //     >
            //         <Button type="danger">Delete</Button>
            //     </Popconfirm>
            // }
        ];

        return (
            <div>
                <div className="advertisement2">
                </div>

                <header className="header2 bg-light">
                    <nav className="navbar  navbar-light">
                        <div className="container">
                            <Link className="navbar-brand" to="/"><img src={logo} alt="logo" className="img-fluid" /></Link>
                            <div style={{ display: 'flex' }}>
                                <Link className="home-btn" to="/"><i className="fas fa-home"></i></Link>
                                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                            </div>
                            <div className="collapse navbar-collapse" id="collapsingNavbar">

                                <ul className="navbar-nav ml-auto">
                                    <li className="nav-item"><Link className="nav-link" to="/">Home</Link> </li>
                                    <li className="nav-item"><Link className="nav-link" to="/account">Profile</Link> </li>
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Settings
                                        </a>
                                        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <a className="nav-link dropdown-toggle nav-link-child" href="#" id="navbarDropdownChild" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Delivery
                                            </a>
                                            <div className="dropdown-menu" aria-labelledby="navbarDropdownChild">
                                                <Link className="dropdown-item" to="/timeslot">TimeSlot</Link>
                                                <Link className="dropdown-item" to="/region">Region</Link>
                                                <Link className="dropdown-item" to="/costs">Costs</Link>
                                            </div>
                                            <Link className="dropdown-item" to="/grocery">Grocery</Link>
                                            <Link className="dropdown-item" to="/offer-type">OfferType</Link>
                                            <Link className="dropdown-item" to="/topic">Topic</Link>
                                            <Link className="dropdown-item" to="/user-group">UserGroup</Link>
                                            <Link className="dropdown-item" to="/product">Product</Link>
                                            <Link className="dropdown-item" to="/product-type">ProductType</Link>
                                            <Link className="dropdown-item" to="/qanda">Question & Answer settings </Link>
                                            <Link className="dropdown-item" to="/focusgroup">Focusgroup settings</Link>
                                            <Link className="dropdown-item" to="/1to1">1 To 1 Offer settings</Link>
                                            <Link className="dropdown-item" to="/ad">Promotional Ads settings</Link>
                                            <Link className="dropdown-item" to="/faq">FAQ</Link>
                                        </div>
                                    </li>
                                    <li className="nav-item"><Link className="nav-link" to="/subscription">Subscriptions</Link> </li>
                                    <li className="nav-item"><Link className="nav-link" to="/insight">Insights</Link> </li>
                                    <li className="nav-item"><Link className="nav-link" to="/invoice">Invoices</Link> </li><li className="nav-item"><Link className="nav-link" to="/login">Logout</Link> </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </header>


                <div className="main-content-bg2">
                    <section>

                        <div className="center1">
                            <div className="card2">
                                <h2><b>OVERVIEW</b></h2>
                                <br />
                                <h4><b>Productgroups</b></h4>
                                <br />
                                <br />
                                <Table
                                    className="components-table-demo-nested"
                                    columns={columns}
                                    dataSource={tableData}
                                    onChange={this.handleChange}
                                    expandedRowRender={this.expandedRowRender}
                                    onRow={(row, rowIndex) => this.handleExpand(row)}
                                    bordered
                                    title={() => <div className="table-operations">
                                        <Button onClick={this.setAgeSort}>Sort Name</Button>
                                        <Button onClick={this.clearAll}>Clear sorters</Button>
                                    </div>}
                                    style={{ width: '100%' }}
                                    tableLayout="fixed"
                                    scroll={{ x: 1250, y: 300 }}
                                />
                            </div>
                        </div>

                        <div className="center1">
                            <div className="card2">
                                <Form
                                    onSubmit={this.handleSubmit}
                                    className="login-form"
                                    hideRequiredMark={true}
                                    encType="multipart/form-data">
                                    <h1 className="heading1" >PRODUCTGROUP SETTINGS</h1>
                                    <Form.Item
                                        label="Name"
                                    >
                                        {getFieldDecorator('name', {
                                            rules: [{ required: true, message: 'Please Input Name!' }],
                                        })(
                                            <Input placeholder="Name" minLength={3} />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label="Grocery"
                                    >
                                        {getFieldDecorator('grocery', {
                                            rules: [{ required: true, message: 'Please Select Grocery!' }],
                                        })(
                                            <Select
                                                showSearch
                                                style={{ backgroundColor: '#fff' }}
                                                placeholder="Select Grocery and Street"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {
                                                    formData.map((v, i) => {
                                                        return <Option value={v._id} key={i}>{`${v.userName}, ${v.streetAddress}`}</Option>
                                                    })
                                                }
                                            </Select>,
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label="Description"
                                    >
                                        {getFieldDecorator('description', {
                                            rules: [{ required: true, message: 'Please Input Description!' }],
                                        })(
                                            <TextArea rows={4} placeholder="Input Description Here!!!" />,
                                        )}
                                    </Form.Item>
                                    <Form.Item>
                                        <SubmitButton loading={loading} disable={disable} />
                                    </Form.Item>
                                </Form>
                            </div>

                        </div>
                        <Footer {...this.props} />
                    </section>
                </div>
            </div>
        )
    }
}

const ProductGroupForm = Form.create({ name: 'normal_login' })(ProductGroup);

const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loginUser: (user) => dispatch(loginUser(user)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(ProductGroupForm)